import React, { Component } from 'react';
import * as Gserv from '../services/GatewayService';
import { UndoTwoTone, PrintTwoTone, Settings} from '@material-ui/icons';
import {Paper, Grid, Typography, IconButton, Button, Tooltip} from '@material-ui/core';
import ReactToPrint from 'react-to-print';
import Logo from '../assets/360_logo.png';
import ThreeSixtyBlock from './360LeadershipSubBlock';

export default class ViewThreeSixtyReport extends Component {
    constructor(props) {
        super(props);
        this.state = {  //Note: designations not reset
            reports_avail: [],
            error: false,
            error_message: '',
            querying: true,
            show_report: false,
            current_record : {},
            report_data: [],
            STEP_CHANGE: [],
            HIGH_P : [],
            OWN : [],
            CUST_EFF : [],
            PROF : [],
            COLLAB : [],
            comments : [],
            overall_ave: 0,
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
        };
        
    }

    componentDidMount = () => {
        this.setState({
            current_record:this.props.current_record,
            querying: true,
            report_data: [],
            comments : [],
            overall_ave: null
        });

        Gserv.sendCommand('query_360_data',this.props.gwt,
        {
            assessee_id: this.props.current_record.assessee_id,
            cycle_id: this.props.current_record.cycle_id
        })
        .then(report_data => {
            // console.log('report_data :>> ', report_data);
            if (report_data.error){
                console.log('error on return from Gserv (query_360_data) :>> ', report_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (report_data.Result!=="Success"){
                console.log('error on return from Gserv (query_360_data) :>> ', report_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                let STEP_CHANGE = [];
                let HIGH_P = [];
                let OWN = [];
                let CUST_EFF = [];
                let PROF = [];
                let COLLAB = [];
                let comments = [];
                let overall_ave = 0;
                for (var i = 0; i < report_data.Records.length; i++){
                    switch (report_data.Records[i].datapoint_code) {
                        case 'STEP_CHANGE':
                            STEP_CHANGE.push(report_data.Records[i])
                            break;
                        case 'HIGH_PERFORMANCE':
                            HIGH_P.push(report_data.Records[i])
                            break;
                        case 'OWNERSHIP':
                            OWN.push(report_data.Records[i])
                            break;
                        case 'CUST_LED_EFFICIENCY':
                            CUST_EFF.push(report_data.Records[i])
                            break;
                        case 'PROFESSIONALISM':
                            PROF.push(report_data.Records[i])
                            break;
                        case 'COLLABORATION':
                            COLLAB.push(report_data.Records[i])
                            break;
                        case '360_COMMENT':
                            comments.push(report_data.Records[i])
                            break;
                        case 'AVE_360_SCORE':
                            overall_ave+= Number(report_data.Records[i].score)
                            break;
                        default:
                            break;
                    }
                }

                overall_ave = Math.round((overall_ave / this.props.current_record.assessment_count)*1000)/100;

                this.setState({
                    report_data: report_data.Records,
                    STEP_CHANGE: STEP_CHANGE,
                    HIGH_P : HIGH_P,
                    OWN : OWN,
                    CUST_EFF : CUST_EFF,
                    PROF : PROF,
                    COLLAB : COLLAB,
                    comments : comments,
                    querying:false,
                    overall_ave: overall_ave
                });

            }
        }); 
    };

    backToParent = () => {
        this.props.closeChild();
    }    

    render() {

        const current_record = this.props.current_record;

        return(
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >

            <Grid item>
            
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1000,
                        padding:15,
                    }}
                >
                    <Tooltip title="Back"><IconButton aria-label='Back' onClick={this.backToParent}><UndoTwoTone /></IconButton></Tooltip>

                    <Tooltip title="Print or save as .pdf">
                        <span>
                        <ReactToPrint
                            content={() => this.componentRef}
                            bodyClass={'printSpecs'}
                            trigger={() => <IconButton aria-label='Print or save as .pdf'><PrintTwoTone /></IconButton>}
                        />
                        </span>
                    </Tooltip>

                </Paper>

                <div id='Print Delimiter' 
                    ref={(response) => (this.componentRef = response)}
                >        

                    <div
                        style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                        
                    >
                        <Grid container direction='row' justifyContent='space-evenly' alignItems='center'>
                            <img
                                    src={Logo}
                                    alt={'360 Logo'}
                                    height={78}
                                    width={161}
                            />
                            <Grid item>
                                <Typography color='primary' variant='h6'>360 Leadership Assessment Report</Typography>
                                <Typography>For : <b>{current_record.name}</b> (Empl.# {current_record.assessee_id}) for cycle <b>{current_record.cycle_code}</b></Typography>
                                <Typography>{current_record.job_title} [<b>{current_record.store_code} {current_record.region}</b>] Reporting to Manager: <b>{current_record.reports_to_rom}</b></Typography>
                                <Typography>Generated : {new Date().toDateString()}</Typography>
                                <Typography><b>{current_record.assessment_count}</b> assessment(s) on file</Typography>
                            </Grid>
                            <Grid item>
                                <Grid container direction='column' justifyContent='center' alignItems='center'> 
                                    <Typography >Overall Average Score:</Typography>
                                    <Typography variant='h6' color='primary'>{this.state.overall_ave}%</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>

                    {this.state.querying&&
                    <Typography
                        style={{marginTop:25}}
                    >
                        <Settings className='icn-spinner' /><br/>
                        Extracting report data...
                    </Typography>}

                    {!this.state.querying&&
                    <Paper
                        elevation={3}
                        style={{
                            // backgroundColor:'blue',
                            width:1000,
                            padding:15
                        }}
                    >

                        <Grid container direction={'row'} justifyContent='space-evenly'>
                            <ThreeSixtyBlock 
                                title={'STEP CHANGE'}
                                data_array={this.state.STEP_CHANGE}
                            />
                            <ThreeSixtyBlock 
                                title={'HIGH PERFORMANCE'}
                                data_array={this.state.HIGH_P}
                            />
                        </Grid>
                        <hr/>
                        <Grid container direction={'row'} justifyContent='space-evenly'>
                            <ThreeSixtyBlock 
                                title={'OWNERSHIP'}
                                data_array={this.state.OWN}
                            />
                            <ThreeSixtyBlock 
                                title={'CUSTOMER-LED EFFICIENCY'}
                                data_array={this.state.CUST_EFF}
                            />
                        </Grid>
                        <hr/>
                        <Grid container direction={'row'} justifyContent='space-evenly'>
                            <ThreeSixtyBlock 
                                title={'PROFESSIONALISM'}
                                data_array={this.state.PROF}
                            />
                            <ThreeSixtyBlock 
                                title={'COLLABORATION'}
                                data_array={this.state.COLLAB}
                            />
                        </Grid>
                    </Paper>}

                    {!this.state.querying&&
                    <Paper
                        elevation={3}
                        style={{
                            // backgroundColor:'blue',
                            width:1000,
                            padding:15,
                        }}
                    >
                        <Grid container direction='column' justifyContent='flex-start' alignItems='flex-start'>
                            <Typography><b>Comments:</b></Typography>
                            {this.state.comments.map(function(item, i){
                                return <Typography key={item.assessment_key}><u>{item.assessment_type}</u> : {item.comment}</Typography>
                            })}
                        </Grid>

                    </Paper>}

                </div>

            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1000,maxWidth:1000, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.backToParent}>Back</Button>}
            </Grid>

        </Grid>
    )}
}